// extracted by mini-css-extract-plugin
module.exports = {"notificationTitle":"NotificationByEmailDisplay_notificationTitle__3JR6s","notificationList":"NotificationByEmailDisplay_notificationList__2YnkN"};